import client from 'lib/api/client';
import type {
  TAnalysisItem,
  TScalpPointEnum,
  IScalpHistoryInfos,
  IScalpResultInfo,
} from './scalp_types';
import { objectToQueryString } from 'utils/@common/utils_common';

// 두피 진단 히스토리 불러오기
export const getScalpHistory = async ({
  userId,
  analysisItem,
  scalpPoint,
  skip,
  take,
}: {
  userId: string;
  analysisItem: TAnalysisItem;
  scalpPoint: TScalpPointEnum | undefined;
  skip: number | undefined;
  take: number | undefined;
}) => {
  const queryString = objectToQueryString({
    analysisItem,
    scalpPoint,
    skip,
    take,
  });
  const res = await client.get<IScalpHistoryInfos>(
    `/my/user/${userId}/scalp/histories?${queryString}`,
  );
  return res.data;
};

export const getScalpResult = async ({
  userId,
  analysisId,
}: {
  userId: string;
  analysisId: string;
}) => {
  const res = await client.get<IScalpResultInfo>(
    '/my/user/' + userId + '/scalp/' + analysisId,
  );
  return res.data;
};
